import _Model from "./_Model";

export default class RelatedConnectionDevice extends _Model {
  constructor(json) {
    super(json);
    this.connectionType = RelatedConnectionDevice.getOrDefault(json, 'connectionType', '');
    this.referenceID = RelatedConnectionDevice.getOrDefault(json, 'referenceID', '');
  }

}
